import React, {FunctionComponent, ReactNode, useEffect, useState} from 'react';
import './styles.scss';

type SwitchContentProps = {
  firstLabel: string;
  secondLabel: string;
  firstContent: ReactNode;
  secondContent: ReactNode;
  lastPosition?: number;
};

const SwitchContent: FunctionComponent<SwitchContentProps> = ({ firstLabel, secondLabel, firstContent, secondContent , lastPosition}) => {
  const [contentIndex, setContentIndex] = useState( 0);

  const handleClick = (value: number) => {
    typeof window !== "undefined" && window.localStorage.setItem("lastPosition", value.toString())
    setContentIndex(value);
  }

  useEffect(() => {
    setContentIndex(lastPosition?lastPosition:0);
  }, [lastPosition])

  return (
    <div className='switch-content'>
      <div className={`switch-buttons ${contentIndex === 1 ? 'right' : 'left'}`}>
        <button
          type='button'
          onClick={() => handleClick(0)}
          className={contentIndex === 0 ? 'active' : ''}
        >
          {firstLabel}
        </button>
        <button
          type='button'
          onClick={() => handleClick(1)}
          className={contentIndex === 1 ? 'active' : ''}
        >
          {secondLabel}
        </button>
      </div>

      <div>
        {contentIndex === 0 && firstContent}
        {contentIndex === 1 && secondContent}
      </div>
    </div>
  );
}

export default SwitchContent;
